var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-traffic',{attrs:{"page":_vm.page,"px-design-id":_vm.pxDesignId,"scenario":_vm.scenario,"validations":_vm.$v},on:{"sync":function($event){return _vm.sync()},"save":function($event){return _vm.save()}}})}
var staticRenderFns = []

export { render, staticRenderFns }